
import React from 'react'
import Navbar from '../components/Navbar'; // adjust path if needed
import Sidebar from '../components/Sidebar';
import '../css/main.css';
import UserStatsPage from '../components/UserStatsPage';

const UserStats = () => {
  return (
    <div className='container-dash bg-gray-50 min-h-screen'>
      <div className='flex'>
        <Sidebar />
        <div className='w-full'>
          <Navbar />
          <UserStatsPage />
        </div>
      </div>
    </div>
  )
}

export default UserStats